import * as type from '@app/constants/mezzoErrors'

export const sync = () => ({
  type: type.SYNC_MEZZO_ERRORS_OPTIONS,
} as const)
